<template>
    <div>

        <div class="row">
            <div class="col">
                <h3>
                    Filtres
                </h3>
                <v-select label="Tag" outlined chips @input="setSelectedTags" :value="selectedTags" :items="tags"
                          no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                          item-text="name" multiple :disabled="tags.length == 0  || loadingApidaeProviders"
                          v-if="!isAspectCampaign">
                </v-select>

                <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                          @input="setSelectedCategories" :value="selectedCategories" item-value="id" item-text="label"
                          multiple :disabled="categories.length == 0 || loadingApidaeProviders"
                          v-if="!isAspectCampaign">
                </v-select>

                <v-select :label="cityWording" outlined chips small-chips deletable-chips :items="communes"
                          @input="setSelectedCommunes" :value="selectedCommunes" item-value="id" item-text="label"
                          multiple
                          :disabled="communes.length == 0 || loadingApidaeProviders"
                          v-if="!isAspectCampaign">
                </v-select>

                <v-select label="Secteur touristique" outlined chips small-chips deletable-chips :items="tourismSectors"
                          @input="setSelectedTourismSectors" :value="selectedTourismSectors" item-value="id"
                          item-text="label" multiple
                          :disabled="tourismSectors.length == 0 || loadingApidaeProviders"
                          v-if="this.account.tis_type.code === 'DAHUB_QUEBEC'">
                </v-select>

                <div class="d-flex justify-content-center"
                     v-if="account.tis_type.code === 'APIDAE' && aspect === undefined || aspect === ''">
                    <strong class="text-primary my-4">ou</strong>
                </div>

                <v-select label="Sélection Apidae" outlined v-if="account.tis_type.code === 'APIDAE'"
                          :items="apidaeSelections" @input="setSelectedApidaeSelection" :value="selectedApidaeSelection"
                          return-object item-text="libelle.libelleFr"
                          :disabled="apidaeSelections.length == 0 || loadingApidaeProviders">
                </v-select>
            </div>
            <div class="col-12 col-lg-8">
                <h3>
                    Prestataires
                    <div class="badge blue-grey darken-2 text-white">
                        <span v-if="!loadingApidaeProviders">{{ providers.length }}</span>
                    </div>
                </h3>

                <v-simple-table v-if="!loadingApidaeProviders" fixed-header class="border mt-5" height="50vh">
                    <thead>
                    <tr>
                        <th class="text-left">Nom</th>
                        <th class="text-left">Catégorie</th>
                        <th class="text-left">{{ cityWording }}</th>
                        <th class="text-left">Destinataire</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="provider in providers" :key="provider.id">
                        <td>{{ provider.name }}</td>
                        <td>{{ provider.category }}</td>
                        <td>{{ provider.commune }}</td>
                        <td>{{ provider.email }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <div v-else class="d-flex justify-content-center p-3">
                    <v-progress-circular class="progressbar mr-2" indeterminate size="40" width="4">
                    </v-progress-circular>
                </div>
            </div>
        </div>

        <div class="text-right mb-5 mt-5">
            <v-btn class="default-button" @click="setCurrentStep(2)">Passer à l'étape suivante</v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"
import * as EmailValidator from "email-validator"

export default {
    name: "Filters",
    props: ["aspect"],
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            panel: [],
            loadingApidaeProviders: true,
            lockSearch: false,
            cityWording: "Commune",
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setSelectedCategories", "setSelectedCommunes", "setSelectedTags",
            "setProviders", "setCurrentStep", "setEmailsValid", "setEmailsWrong", "setSelectedApidaeSelection",
            "setSelectedTourismSectors"]),
        getProviders() {
            this.loadingApidaeProviders = true

            let payload = {
                categoryIds: this.selectedCategories,
                communeIds: this.selectedCommunes,
                tagIds: this.selectedTags,
                tourismSectors: this.selectedTourismSectors,
            }
            this.$http.post("auth/campaigns/providers", payload).then(res => {
                this.setProviders(res.body.data.providers)
                this.setEmailLists()

                this.$global.$emit("reload-info")

                this.loadingApidaeProviders = false
            })
        },
        getApidaeProviders() {
            if (this.selectedApidaeSelection !== null) {
                this.loadingApidaeProviders = true

                let payload = {
                    projectId: this.selectedApidaeSelection.projectId,
                    selectionId: this.selectedApidaeSelection.id,
                    selectionName: this.selectedApidaeSelection.nom,
                    disabled: ["DOMAINE_SKIABLE", "STRUCTURE"],
                }

                if (this.aspect !== undefined && this.aspect !== "") {
                    payload.aspect = this.aspect
                }

                this.$http.post("auth/account/apidae-selections/providers", payload).then(res => {
                    this.setProviders(res.body.data.providers)
                    this.setEmailLists()
                    this.loadingApidaeProviders = false
                    this.$global.$emit("reload-info")
                })
            }
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = "E-mail non renseigné"
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
    },
    computed: {
        ...mapState("account", ["tags", "categories", "communes", "account", "apidaeSelections", "tourismSectors"]),
        ...mapState("createCmaj", ["selectedCategories", "selectedCommunes", "selectedTags",
            "providers", "emailsValid", "emailsWrong", "selectedApidaeSelection", "selectedTourismSectors"]),
        isAspectCampaign() {
            return this.aspect !== undefined && this.aspect !== "" && this.aspect !== null
        },
    },
    watch: {
        selectedCategories() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedCategories.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedCommunes() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedCommunes.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedTags() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedTags.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedTourismSectors() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedTourismSectors.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedApidaeSelection() {
            this.getApidaeProviders()

            this.lockSearch = true

            if (this.selectedApidaeSelection !== null) {
                this.setSelectedCommunes([])
                this.setSelectedCategories([])
                this.setSelectedTags([])
                this.setSelectedTourismSectors([])
            }

            setTimeout(() => {
                this.lockSearch = false
            }, 500)
        },
    },
    created() {
        this.$store.dispatch("resource/fetchCategories")
        this.$store.dispatch("account/fetchTags")
        this.$store.dispatch("account/fetchApidaeSelections")

        if (this.selectedApidaeSelection) {
            this.getApidaeProviders()
        } else if (this.aspect === undefined || this.aspect === "") {
            this.getProviders()
        } else {
            this.loadingApidaeProviders = false
        }

        if (this.account.configurations.quebec) {
            this.cityWording = "Municipalité"
        }
    },
}
</script>